import { Link } from 'react-router-dom';
import Seo from './Seo';

const NotFoundPage = () => {
  return (
    <main className="min-h-screen bg-gray-50 px-6 py-24" data-status-code="404">
      <Seo
        title="Page Not Found - Uumail"
        description="The Uumail page you requested does not exist. Return to the private email alias homepage."
        path="/404"
      />
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-blue-600">404</p>
        <h1 className="mt-4 text-4xl font-bold text-gray-950">Page not found</h1>
        <p className="mt-4 text-lg text-gray-700">
          This page is not available. Return to Uumail to create private email aliases and protect your inbox.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex rounded-md bg-blue-600 px-5 py-3 font-medium text-white transition-colors hover:bg-blue-700"
        >
          Back to homepage
        </Link>
      </div>
    </main>
  );
};

export default NotFoundPage;
